/** The signed-out sheet's watch (the forum sync round, 2026-11-02; brief rule 9, review findings 20 and 22). Any API answer 401 (and the live
 *  socket's close 4401) while the app holds a signed-in person makes one more read of `/api/v1/me`; only when that answers 401 too is the
 *  person signed out, and the sheet covers the app. Never on the sign-in page, never after a deliberate Sign out, and never for the `me`
 *  check's own 401 (it reads with a plain fetch, outside the API layer that reports). While the sheet is up, coming back to the tab reads
 *  `me` again: a sign-in in another tab closes the sheet. */
type State = "in" | "checking" | "out";
let state: State = "in";
let signedIn = false;
let deliberate = false;
const listeners = new Set<() => void>();
const set = (next: State) => { if (state === next) return; state = next; for (const l of listeners) l(); };
const onSignInPage = () => window.location.pathname === "/signin" || window.location.pathname.startsWith("/signin/");

export const signedOutNow = (): boolean => state === "out";
export const subscribeSignedOut = (fn: () => void): (() => void) => { listeners.add(fn); return () => { listeners.delete(fn); }; };
let holder: string | null = null;
/** the person the app holds (App, from the `me` it loaded), or null; a new person signed in starts with a clean watch */
export const holdSignedIn = (userId: string | null): void => {
  if (userId && userId !== holder) { deliberate = false; if (state !== "in") queueMicrotask(() => set("in")); } // after the render that called it
  holder = userId; signedIn = !!userId;
};
/** a Sign out the person chose: nothing after it is a reason for the sheet */
export const markDeliberateSignOut = (): void => { deliberate = true; };
/** the requests whose 401 is not a lost session: the `me` read itself and the sign-in library's own calls */
export const reportsSignedOut = (url: string): boolean => !url.startsWith("/api/v1/me") && !url.startsWith("/api/auth/");

/** a 401 from the API or the live socket: confirm it once with `me` */
export function noticeUnauthorized(): void {
  if (!signedIn || deliberate || state !== "in" || onSignInPage()) return;
  set("checking");
  void meAnswers().then((status) => set(status === 401 && !deliberate && !onSignInPage() ? "out" : "in"));
}
/** while the sheet is up: a session found again (another tab signed in) closes it */
export function recheckSignedIn(): void {
  if (state !== "out") return;
  void meAnswers().then((status) => { if (status !== null && status !== 401) set("in"); });
}
async function meAnswers(): Promise<number | null> {
  try { return (await fetch("/api/v1/me", { credentials: "same-origin", cache: "no-store" })).status; } catch { return null; }
}
